<template>
<div class="animated fadeIn">

	<div class="row">
		<div class="col-lg-12 form-group">
			<h3 class="animated slideInDown"><fa-icon icon="map-marker-alt" /> Posições</h3>
		</div>
	</div>

	<div class="row">

		<div class="col-sm-4 form-group">

			<!-- <pre>{{form.periodo}}</pre> -->
			<date-picker ref="date"
						:input-class="'form-control form-control-sm '"
						v-model="form.periodo"
						format="DD/MM/YYYY"
						range
						:shortcuts="false"
						:confirm="_isMobile"
						type="date"
						lang="pt-br"></date-picker>
		</div>

		<div class="col-sm-3 form-group">
			<button :disabled="form.equipamento == '' && form.periodo.length < 2" @click="carregaPosicao()" class="btn btn-sm btn-block btn-success">
				<fa-icon icon="sync-alt"/> CARREGAR
			</button>
		</div>

		<div class="col-sm-5 form-group" v-if="buscou">

			<button @click="clicReenviar" v-if="_getPrivilegio(30)" class="btn btn-outline-dark btn-sm float-right">
				<fa-icon icon="paper-plane"/> Reenviar
			</button>
		</div>
	</div>

	<fl-table 	ref="table"
				v-if="buscou"
				class="animated fadeIn fast"
				tableClass="table-sm"
				:perPage="1000"
				@click-get-config="clickGetConfig"
				columnStartSortable="id"
				:columns="geraCabecalhos()" />

	<flModal width="40%" ref="modalReenviar">
		<template v-slot:header><fa-icon icon="paper-plane" /> Reenviar</template>
		<flReenvio ref="CPReenvio" />
	</flModal>

	<flModal width="50%" ref="modalConfig">
		<template v-slot:header><fa-icon icon="cog" /> Config Report</template>
		<flPosicaoConfig  :config="config" />
	</flModal>
</div>
</template>

<script>
import _ from 'lodash'
// import flTabelaPosicao from './tabela-posicao.vue'
import flReenvio from '../reenvio.vue'
import flPosicaoConfig from './posicao-config.vue'
import flModal from '../../../../components/modal/main.vue'
import moment from 'moment'
import axios from '../../../../routers/axios'
import flTable from '../../../../components/table/main.vue'


export default {

	components: {
		// flTabelaPosicao,
		flReenvio,
		flPosicaoConfig,
		flModal,
		flTable
	},

	data() {
		return {
			form: {
				equipamento: "",
				cliente: "0",
				periodo: [],
			},

			buscou: false,
			equipamentos: [],
			data: "",
			clientes: [],
			trecho: {},
			config: {}
		};
	},

	computed: {
		_posicoes() {
			if (this.data == "") {
				return this.posicoes;
			} else {
				return _.filter(this.posicoes, o => {
					return o._data == this.data;
				});
			}
		}
	},

	mounted() {
		axios.get(this._getUrl("api/equipamento")).then(response => {
			this.load = false;
			this.equipamentos = _.orderBy(response.data, ["prefixo"], ["asc"]);
		});

		axios.get(this._getUrl("api/cliente")).then(response => {
			this.clientes = _.orderBy(response.data, ["nome"], ["asc"]);
		});
	},

	methods: {

		carregaDados(equipamento){
			this.form.equipamento = equipamento
		},

		clickGetConfig(item){

			// nao faz nenhuma acao se nao for config
			if(item._object.trigger != 'CONFIG_REPORT') return false

			this.$notify.loadIn('Carregando Configuração')

			axios.get(this._getUrl(`api/equipamentoPosicaoConfiguracao/${this.form.equipamento.imei}/${item._object.idPosicao}`)).then(response => {
				this.$refs.modalConfig.show()
				this.config = response.data
			})
		},


		clicReenviar(){

			this.$refs.modalReenviar.show()
			this.$nextTick(() => { this.$refs.CPReenvio.carregar(this.form.equipamento, 'P', this.form.periodo[0], this.form.periodo[1]) })
		},

		carregaPosicao() {
			this.$notify.loadIn('Carregando')
			let data ={
				IMEI: this.form.equipamento.imei,
				inicioUTC:  new moment(this.form.periodo[0]).format("YYYY-MM-DD"),
				fimUTC: new moment(this.form.periodo[1]).format("YYYY-MM-DD"),
			}
			axios.post(this._getUrl("api/equipamentoposicao"), data).then(response => {
				this.buscou = true
				response.data = _.filter(response.data, o => {return !o.aberto }).map(item => {
					item.dataUTC = new moment(item.dataUTC).format("DD/MM/YYYY HH:mm:ss")
					item.dataUTCInserido = new moment(item.dataUTCInserido).format("DD/MM/YYYY HH:mm:ss")
					return item;
				})

				let list = response.data.map(item => { return this.geraColunas(item) })

				this.$nextTick(() => {
					this.$refs.table.loadTable(list)
				})

			});
		},

		geraColunas(item){

			let itemLista = {}
			let columns = []

			let cls = ""

			if(item.trigger == "CONFIG_REPORT"){
				cls = "table-secondary"
			}

			if(item.trigger == "ACTIVATION"){
				cls = "table-success"
			}


			if(item.trigger == "DEACTIVATION"){
				cls = "table-info"
			}

			columns.push({
				html: `<small>${item.trigger}</small>`,
				clickable: true,
				event: 'click-get-config',
				class: cls
			})


			// columns.push({html: `<small>${item.trigger}</small>` })
			columns.push({html: `<small>${item.alertType == null ? '' : item.alertType}</small>` })
			columns.push({html: `<small>${item.dataUTC}</small>` })
			columns.push({html: `<small>${item.lat}</small>` })
			columns.push({html: `<small>${item.lng}</small>` })
			columns.push({html: `<small>${item.altitude}m</small>` })
			columns.push({html: `<small>${item.velocidade}kn</small>` })
			columns.push({html: `<small>${item.direcao}°</small>` })
			columns.push({html: `<small>${item.emMovimento}</small>` })
			columns.push({html: `<small>${item.source}</small>` })
			columns.push({html: `<small>${item.battery}%</small>` })
			columns.push({html: `<small>${item.temp} °C</small>` })
			columns.push({html: `<small>${item.dataUTCInserido}</small>` })
			columns.push({html: `<small>${item.transport}</small>` })

			itemLista._object = item
			itemLista.columns = columns
			return itemLista
		},

		geraCabecalhos(){

			let columns = []
			columns.push({name: 'Trigger', key: 'trigger' })
			columns.push({name: 'Alert', key: 'alertType' })
			columns.push({name: 'UTC', key: 'dataUTC' })
			columns.push({name: 'Lat', key: 'lat' })
			columns.push({name: 'Lng', key: 'lng' })
			columns.push({name: 'Altitude', key: 'altitude' })
			columns.push({name: 'Vel.', key: 'velocidade' })
			columns.push({name: 'Direção', key: 'direcao' })
			columns.push({name: 'Mov.', key: 'emMovimento' })
			columns.push({name: 'Source', key: 'source' })
			columns.push({name: 'Bat.', key: 'source' })
			columns.push({name: 'Temp', key: 'temp' })
			columns.push({name: 'Hor. Inserção', key: 'dataUTCInserido' })
			columns.push({name: 'Transport', key: 'transport' })

			return columns
		},

	}
};
</script>



// WEBPACK FOOTER //
// src/views/equipamento/detalhe/posicao/main.vue